var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldAlt2Check(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23638 4.66346H5.0778C6.65719 4.66346 8.20126 4.18386 9.5154 3.28511L10.8906 2.34459C11.5624 1.88514 12.4376 1.88514 13.1094 2.34459L14.4846 3.28511C15.7987 4.18386 17.3428 4.66346 18.9222 4.66346H19.7636C20.4465 4.66346 21 5.23133 21 5.93182V9.15651C21 14.7972 17.6245 19.8593 12.4999 21.9038C12.1784 22.0321 11.8216 22.0321 11.5001 21.9038C6.37552 19.8593 3 14.7972 3 9.15651V5.93182C3 5.23133 3.55355 4.66346 4.23638 4.66346ZM17.5303 9.31098C17.8232 9.01051 17.8232 8.52336 17.5303 8.22289C17.2374 7.92242 16.7626 7.92242 16.4697 8.22289L11 13.834L8.53033 11.3005C8.23744 11 7.76256 11 7.46967 11.3005C7.17678 11.601 7.17678 12.0881 7.46967 12.3886L10.4697 15.4662C10.7626 15.7667 11.2374 15.7667 11.5303 15.4662L17.5303 9.31098Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldAlt2Check);
export default __webpack_public_path__ + "static/media/shield-alt-2-check.c2abe38f2d0a2a67353017d910811866.svg";
export { ForwardRef as ReactComponent };